// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1LV3J{position:absolute;top:0;width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;color:#fff}._3hhC8{background-color:#231815}._29G_S{margin-bottom:2rem}@media(max-width:767px){._29G_S{display:none}}._2nh5w,.dYOrE{margin-bottom:1.5rem}", ""]);
// Exports
exports.locals = {
	"root": "_1LV3J",
	"comingSoon": "_3hhC8",
	"comingSoonImage": "_29G_S",
	"description": "_2nh5w",
	"title": "dYOrE"
};
module.exports = exports;
